import request from "../utils/request"

export function fetchDesignProjects(params) {
  return request({ url: "/office/design/projects", method: "get", params })
}

export function fetchDesignThemes(params) {
  return request({ url: "/office/design/themes", method: "get", params })
}

export function fetchDesignWorkspace(projectId) {
  return request({ url: `/office/design/projects/${projectId}`, method: "get" })
}

export function createDesignProject(data) {
  return request({ url: "/office/design/projects", method: "post", data })
}

export function updateDesignProject(projectId, data) {
  return request({ url: `/office/design/projects/${projectId}`, method: "put", data })
}

export function uploadDesignScreens(projectId, files, onUploadProgress) {
  const data = new FormData()
  files.forEach(file => data.append("files", file))
  return request({
    url: `/office/design/projects/${projectId}/screens/upload`,
    method: "post",
    data,
    timeout: 120000,
    onUploadProgress
  })
}

export function updateDesignScreen(screenId, data) {
  return request({ url: `/office/design/screens/${screenId}`, method: "put", data })
}

export function setDesignScreenCompleted(screenId, completed) {
  return request({ url: `/office/design/screens/${screenId}/completion`, method: "patch", data: { completed } })
}

export function deleteDesignScreen(screenId) {
  return request({ url: `/office/design/screens/${screenId}`, method: "delete" })
}

export function uploadDesignAssets(projectId, screenId, files, onUploadProgress) {
  const data = new FormData()
  files.forEach(file => data.append("files", file))
  return request({
    url: `/office/design/projects/${projectId}/assets/upload`,
    method: "post",
    params: { screenId },
    data,
    timeout: 180000,
    onUploadProgress
  })
}

export function deleteDesignAsset(assetId) {
  return request({ url: `/office/design/assets/${assetId}`, method: "delete" })
}
